module.exports = __webpack_public_path__ + "static/media/victoria-harvey.38952bd5.jpg";